import { useContext, createContext } from 'react';
import { HandlersProps } from '../worker/handlers';

export const WorkerHandlersContext = createContext<HandlersProps>({
  functions: {},
  state: {},
});

export function useWorkerHandlers() {
  return useContext(WorkerHandlersContext);
}
